module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_8023.cd933d2b.png";